import MessageTimestamp from './MessageTimestamp';
import { Calendar } from 'lucide-react';
import MessageImageGrid from './MessageImageGrid';
import CalendarShareButton from './ChatSender/CalendarShareButton';
import MessageMenu from './MessageMenu';
import { useDispatch } from 'react-redux';
import { setImageViewer } from '../../../Redux/store';
import { formatTimeShort } from '../../../data/functions';

function Message({ message, currentUserId, onRetry, onSetTab }) {
  const dispatch = useDispatch();

  const isMine = message.sender_id === currentUserId;

  return (
    <div
      className={`flex flex-col gap-0.5 ${isMine ? 'items-end' : 'items-start'} ${onRetry ? 'cursor-pointer' : ''}`}
      onClick={onRetry}
    >
      <div
        className={`relative max-w-[75%] min-w-[40px] min-h-[40px] rounded-2xl pl-3 pr-6 pt-2 pb-2 text-sm ${
          isMine
            ? 'rounded-tr-sm bg-primary text-primary-foreground'
            : 'rounded-tl-sm bg-secondary text-secondary-foreground'
        } ${message.sending ? 'opacity-50' : ''}`}
      >
        {/* Message menu button */}
        {isMine && <MessageMenu message={message} chatId={message.chat_id} />}

        {message.deleted ? (
          <div className={`italic ${isMine ? 'text-white/70' : 'text-muted-foreground'}`}>Deleted {formatTimeShort(message.deleted_at)}</div>
        ) : (
          <>
            {/* Display attachments */}
            {(message.attachments && message.attachments.length > 0) || (message.image_urls && message.image_urls.length > 0) ? (
              <div>
                {/* Images grid - handle both attachments (uploads) and image_urls (real messages) */}
                {(message.attachments?.filter(a => a.type === 'image').length > 0 || message.image_urls?.length > 0) && (
                  <>
                    <MessageImageGrid
                      images={[
                        ...(message.attachments?.filter(a => a.type === 'image') || []),
                        ...(message.image_urls || [])
                      ]}
                      currentUserId={currentUserId}
                      senderId={message.sender_id}
                      onImageClick={(images, startIndex) => {
                        // Pass JSONB objects directly to setImageViewer (no URL wrapping)
                        // Filter out preview-only upload attachments (not stored in DB)
                        const dbImages = images.filter(img => !img.preview);
                        dispatch(setImageViewer({ images: dbImages, initialIndex: startIndex }));
                      }}
                    />
                  </>
                )}
                {/* Calendar button */}
                {message.attachments?.some(a => a.type === 'calendar' || a.type === 'calendar_share' || a.type === 'calendar_request') && (
                  <div className="mb-2">
                    {message.attachments?.filter(a => a.type === 'calendar' || a.type === 'calendar_share' || a.type === 'calendar_request').map((attachment) => (
                      <CalendarShareButton
                        key={attachment.id}
                        message={message}
                        attachment={attachment}
                        onSetTab={onSetTab}
                      />
                    ))}
                  </div>
                )}
              </div>
            ) : null}
            {message.body && <div>{message.body}</div>}
          </>
        )}
      </div>
      <div className="flex items-center gap-1 text-[10px] text-muted-foreground">
        <MessageTimestamp
          message={message}
          currentUserId={currentUserId}
        />
      </div>
    </div>
  );
}

export default Message;
